<div class="navigation-style-selector">
  <div
    *ngFor="let option of options"
    class="style-card"
    [class.selected]="value === option.value"
    [class.disabled]="disabled"
    (click)="selectOption(option.value)"
  >
    <ng-container *ngIf="getConfig(option.value) as config">
      <div class="card-icon-wrapper">
        <div class="card-icon">
          <img [src]="config.icon" [alt]="option.name" />
        </div>
      </div>
      <div class="card-separator"></div>
      <div class="card-content">
        <div class="card-title">{{ config.titleKey | translate }}</div>
        <div class="card-description">{{ config.descriptionKey | translate }}</div>
      </div>
    </ng-container>
  </div>
</div>
